import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { motion, useAnimation } from "framer-motion";
import LoaderContext from "../../components/LoaderContext";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  card: {
    position: "relative",
    minWidth: "320px",
    height: "440px",
    borderRadius: "15px",
    margin: "30px",
    transition: "0.5s",
    [theme.breakpoints.down("lg")]: {
      minWidth: "300px",
      height: "400px",
    },
    [theme.breakpoints.down("md")]: {
      minWidth: "300px",
      height: "380px",
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: "280px",
      height: "380px",
    },
    [theme.breakpoints.down("xs")]: {
      minWidth: "320px",
      height: "440px",
    },
  },
}));

export default function ProjectMobile() {
  const classes = useStyles();
  const controls = useAnimation();
  const { isLoading } = useContext(LoaderContext);

  const [value, setValue] = React.useState(0);
  const [active, setActive] = React.useState("");

  useEffect(() => {
    if (!isLoading) {
      controls.start((i) => ({
        opacity: 1,
        y: 0,
        transition: {
          delay: 1.8 + i * 0.1,
        },
      }));
    } else {
      controls.start({ opacity: 0, y: 0 });
    }
  }, [isLoading, controls]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleClick = (event) => {
    setActive(event.target.id);
    console.log(active);
  };

  console.log("value", value);

  const handleChangeButton = (e) => {
    setValue(e);
  };

  return (
    <>
      <Container maxWidth="xl">
        <Box
          sx={{
            alignItems: "center",
            p: 1,
            m: 1,
          }}
        >
          <div className="card-container">
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              columns={{ xs: 10, sm: 10, md: 12 }}
            >
              <div className={classes.root}>
                <motion.div animate={controls} custom={0}>
                  <TabPanel value={value} index={0}>
                    <motion.div
                      custom={0}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.5, duration: 1 }}
                    >
                      <div className={`card ${classes.card}`}>
                        <div className="card-box card-box1">
                          <div className="card-content">
                            <h3>Balance Sheet</h3>
                            <p>
                              Its a balance-sheet-system app, which is build in
                              React & Firebase
                            </p>
                            <a href="https://react-balance-sheet-891c5.web.app/">
                              Live Demo
                            </a>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </TabPanel>
                  <TabPanel value={value} index={1}>
                    <motion.div
                      custom={2}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.5, duration: 1 }}
                    >
                      <div className={`card ${classes.card}`}>
                        <div className="card-box card-box2">
                          <div className="card-content">
                            {/* <h2>02</h2> */}
                            <h3>Books-Stack</h3>
                            <p>
                              Its a simple website for books. Which is build
                              with Next.Js , Node.Js & Mongo DB.
                            </p>
                            <a href="https://books-stack-48272.web.app/">
                              Live Demo
                            </a>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </TabPanel>
                  <TabPanel value={value} index={2}>
                    <motion.div
                      custom={3}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.5, duration: 1 }}
                    >
                      <div className={`card ${classes.card}`}>
                        <div className="card-box card-box3">
                          <div className="card-content">
                            {/* <h2>03</h2> */}
                            <h3>E-Learning</h3>
                            <p>
                              Its a product based application, which is build in
                              Next.JS & MongoDB.
                            </p>
                            <a href="https://www.roadtodevelopers.com/">
                              Live Demo
                            </a>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </TabPanel>
                </motion.div>
              </div>
            </Grid>

            <Grid
              container
              justifyContent="center"
              alignItems="center"
              columns={{ xs: 10, sm: 14, md: 20 }}
            >
              <Grid item xs={2}>
                <motion.div
                  animate={controls}
                  custom={1}
                  style={{ width: "100%" }}
                >
                  <motion.div
                    custom={4}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 1, duration: 1 }}
                  >
                    <Button
                      variant="outlined"
                      color="primary"
                      className={value === 0 ? "active" : undefined}
                      onClick={() => setValue(0)}
                    >
                      1
                    </Button>
                  </motion.div>
                </motion.div>
              </Grid>

              <Grid item xs={2}>
                <motion.div
                  animate={controls}
                  custom={2}
                  style={{ width: "100%" }}
                >
                  <motion.div
                    custom={5}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 1.5, duration: 1 }}
                  >
                    <Button
                      variant="outlined"
                      color="primary"
                      className={value === 1 ? "active" : undefined}
                      onClick={() => setValue(1)}
                    >
                      2
                    </Button>
                  </motion.div>
                </motion.div>
              </Grid>
              <Grid item xs={2}>
                <motion.div
                  animate={controls}
                  custom={3}
                  style={{ width: "100%" }}
                >
                  <motion.div
                    custom={6}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 2, duration: 1 }}
                  >
                    <Button
                      variant="outlined"
                      color="primary"
                      className={value === 2 ? "active" : undefined}
                      onClick={() => setValue(2)}
                    >
                      3
                    </Button>
                  </motion.div>
                </motion.div>
              </Grid>
            </Grid>
          </div>
        </Box>
      </Container>
    </>
  );
}
